export default __webpack_public_path__ + "static/media/Group9244.4d58055f.svg";